"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSync(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M10.118 2.586a.766.766 0 01-.511.955C6.04 4.622 3.532 8.051 3.532 12c0 3.902 2.445 7.043 5.988 8.075l-1.311-2.625a.766.766 0 01.252-.975l.09-.053a.766.766 0 01.975.253l.053.09 2.042 4.085a.766.766 0 01-.252.975l-.09.052-4.085 2.043a.766.766 0 01-.775-1.317l.09-.053 2.228-1.115C4.746 20.114 2 16.467 2 12c0-4.62 2.945-8.646 7.163-9.924a.766.766 0 01.955.511zm7.63-2.162a.766.766 0 01-.252.974l-.09.053-2.231 1.115c3.993 1.322 6.74 4.967 6.74 9.435 0 4.619-2.948 8.648-7.163 9.924a.766.766 0 01-.444-1.466c3.565-1.08 6.075-4.51 6.075-8.458 0-3.9-2.444-7.04-5.988-8.073l1.311 2.623a.766.766 0 01-.252.975l-.09.053a.766.766 0 01-.975-.253l-.053-.09-2.042-4.085a.766.766 0 01.252-.975l.09-.052L16.721.08a.766.766 0 011.028.343z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgSync;
exports.default = _default;